import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
    e.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <a href="/" className="flex items-center gap-3 cursor-pointer">
            <img 
              src="https://public.readdy.ai/ai/img_res/5a0c2242-0ad2-42d9-9fe3-25bf4e6b12bb.png" 
              alt="Gentle Roots Home Care" 
              className="h-16 w-auto object-contain"
            />
          </a>
          
          <div className="flex items-center gap-8">
            <a 
              href="#about" 
              onClick={(e) => scrollToSection(e, 'about')}
              className={`font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-[#2C2C2C] hover:text-[#6B8E6F]' : 'text-white hover:text-[#6B8E6F]'
              }`}
            >
              About Us
            </a>
            <a 
              href="#services" 
              onClick={(e) => scrollToSection(e, 'services')}
              className={`font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-[#2C2C2C] hover:text-[#6B8E6F]' : 'text-white hover:text-[#6B8E6F]'
              }`}
            >
              Services
            </a>
            <a 
              href="#mission" 
              onClick={(e) => scrollToSection(e, 'mission')}
              className={`font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-[#2C2C2C] hover:text-[#6B8E6F]' : 'text-white hover:text-[#6B8E6F]'
              }`}
            >
              Mission
            </a>
            <Link 
              to="/careers" 
              className={`font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-[#2C2C2C] hover:text-[#6B8E6F]' : 'text-white hover:text-[#6B8E6F]'
              }`}
            >
              Careers
            </Link>
            <a 
              href="#contact" 
              onClick={(e) => scrollToSection(e, 'contact')}
              className="px-6 py-2 bg-[#6B8E6F] text-white rounded-lg font-medium hover:bg-[#5a7a5e] transition-colors cursor-pointer whitespace-nowrap"
            >
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}
